// extracted by mini-css-extract-plugin
module.exports = {"table":"dp_table_table__1AJG5"};